import React from 'react';
import { css } from '@emotion/react';
import { useChatPlayContext } from '@provider/ChatPlayProvider';
import { PlayChapterInfo } from '@customTypes/chapter';
import { Statement } from '@/customTypes/chatStory';

import ToastItem from './ToastItem';

interface IToastList {
  playChapterInfo: PlayChapterInfo | undefined;
  onPress?: () => void;
}

const ToastList = ({ playChapterInfo, onPress }: IToastList) => {
  const { toastList, setToastList } = useChatPlayContext();

  const removeToast = (toast?: Statement) => {
    setToastList((prev) =>
      prev.filter((item) => item.sourceLine !== toast?.sourceLine),
    );
  };

  return (
    <div css={toastListContainer}>
      {toastList.map((toast) => (
        <ToastItem
          key={toast.sourceLine}
          toast={toast}
          playChapterInfo={playChapterInfo}
          onClickToast={onPress}
          onRemoveToast={removeToast}
        />
      ))}
    </div>
  );
};

const toastListContainer = css`
  width: 100%;
  position: absolute;
  bottom: 35%;
  display: flex;
  flex-direction: column;
`;

export default ToastList;
